import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

export default {
  install(Vue) {
    const projectHub = new Vue()
    Vue.prototype.$projectHub = projectHub

    let connection = null
    let startedPromise = null
    let manuallyClosed = null

    connection = new HubConnectionBuilder()
      .withUrl(`${process.env.VUE_APP_BACKEND_URL}/notif/project`)
      .configureLogging(LogLevel.None)
      .build()

    function start() {
      startedPromise = connection.start()
        .catch(err => {
          console.error('Failed to connect with hub', err)
          return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
        })
      return startedPromise
    }

    if (!startedPromise) {
      // Forward hub events through the event, so we can listen for them in the Vue components
      connection.on('SendMessage', (message) => {
        projectHub.$emit('receive-push', message)
      })

      connection.on('ReceiveMessage', (message) => {
        projectHub.$emit('receive-all', message)
      })

      connection.onclose(() => {
        if (!manuallyClosed) start()
      })

      // Start everything
      manuallyClosed = false
      start()
    }

    Vue.prototype.stopSignalR = () => {
      if (!startedPromise) return

      manuallyClosed = true
      return startedPromise
        .then(() => connection.stop())
        .then(() => { startedPromise = null })
    }

    projectHub.receiveMessage = (data) => {
      if (!startedPromise) return

      return startedPromise
        .then(() => connection.invoke('ReceiveMessage', data))
        .catch('project hub' + console.error)
    }
  }
}
